var SCM = SCM || {};

SCM.DropdownContainment = (function ($) {

    var viewportMarginPx = 8;
    var shiftProperty = '--dropdown-viewport-shift';
    var shiftedClass = 'dropdown-viewport-shifted';

    return {
        keepInViewport: keepInViewport
    };

    function keepInViewport($menus) {
        $menus.each(function (index, menu) {
            _clearShift(menu);

            var shift = _shiftNeededToFitViewport(menu.getBoundingClientRect());
            if (shift !== 0) {
                menu.style.setProperty(shiftProperty, shift + 'px');
                menu.classList.add(shiftedClass);
            }
        });
    }

    function _shiftNeededToFitViewport(bounds) {
        var minLeft = viewportMarginPx;
        var maxRight = document.documentElement.clientWidth - viewportMarginPx;

        if (bounds.left < minLeft) {
            return minLeft - bounds.left;
        }
        if (bounds.right > maxRight) {
            return Math.max(maxRight - bounds.right, minLeft - bounds.left);
        }
        return 0;
    }

    function _clearShift(menu) {
        menu.classList.remove(shiftedClass);
        menu.style.removeProperty(shiftProperty);
    }

})(jQuery);
